import { useState } from "react";
import type { UploadFile } from "antd/es/upload/interface";
import type { RcFile } from "antd/es/upload";
import { message } from "antd";
import { storage } from "../firebase/firebase"; // Import your Firebase configuration
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage"; // Firebase storage functions
// import { FileTypes } from "enum/file-type";

export type AttachmentsType = { filename: string; data: string; link?: string };

export type ImageType = { documentName: string; documentID: string; url: string };
export type ConsentDocumentType = {
  documentName: string;
  documentID: string;
  url?: string;
  documentDescription?: string;
};


const useUploadFiles = () => {
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [documentID, setDocumentId] = useState<string | null>(null);
  const [uploading, setUploading] = useState<boolean>(false);

  const [cvID, setCVId] = useState<string | null>(null);
  const [certificateId, setCertificateId] = useState<any>({});

  const getFileLink = async (id: string) => {
    try {
      // Assuming you may use the file URL from Firebase in the future
      return [{ name: id, url: `firebase-url/${id}`, id }];
    } catch (error) {
      console.error(error);
    }
  };

  const normFile = (e: any) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e?.fileList;
  };

  const onChange = (info: any) => {
    // const { status } = info?.file;
    return info?.file;
  };

  const beforeUpload = (file: RcFile) => {
    const isLt2M = file.size / 1024 / 1024 < 20;
    if (!isLt2M) {
      message.error("File must be smaller than 20MB!");
      return false;
    }
    return isLt2M;
  };

  const uploadImage = async (
    options: any,
    payload: {
      id?: string;
      enumeratorId?: string;
      description?: string;
      type: string;
      service: string;
      tags: string[];
      isConsentDocument?: boolean;
      shouldNotAllowMultipleFiles?: boolean;
      fieldName?: number;
    },
    successFn?: (id: string) => void
  ) => {
    const { onSuccess, onError, file } = options;

    setUploading(true);

    const bodyFormData: any = new FormData();
    bodyFormData.append("files", file);
    bodyFormData.append("description", payload.description);
    bodyFormData.append("type", payload.type);
    bodyFormData.append("service", payload.service);
    bodyFormData.append("tags", payload.tags);

    setFileList([
      ...fileList,
      {
        percent: 50,
        uid: "2",
        name: "Uploading",
        status: "uploading",
      },
    ]);
    
    try {
      // Upload the file to Firebase Storage
      let type = payload.type.charAt(0).toLowerCase() + String(payload.type).slice(1);

      const storageRef = ref(storage, `${type}/${payload.id}/${payload.enumeratorId}/${file.name}`);
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          // You can track upload progress here if needed
        },
        () => {
          message.error("File upload failed.");
          setUploading(false);
        },
        async () => {
          // Get the download URL after the upload completes
          const downloadURL = await getDownloadURL(storageRef);
          setDocumentId(downloadURL);

          setFileList([
            ...fileList,
            {
              uid: "3", // Adjust UID as needed
              name: file.name,
              status: "done",
              url: downloadURL, // Use Firebase download URL
            },
          ]);

          successFn?.(downloadURL); // Send the URL as the file ID

          message.success(`File uploaded successfully.`);
          setUploading(false);
        }
      );

      onSuccess("Ok"); // Final success callback
    } catch (err) {
      new Error("Upload failed");
      onError({ error: err });
    }
  };

  return {
    uploadImage,
    onChange,
    fileList,
    setFileList,
    normFile,
    beforeUpload,
    documentID,
    setDocumentId,
    getFileLink,
    cvID,
    certificateId,
    setCVId,
    setCertificateId,
    uploading,
  };
};

export { useUploadFiles };
